import { createContext, useContext } from "react";
import { ProjectCreationContextProps } from "@pages/create-project/project-creation-context-types";

export const ProjectCreationContext =
  createContext<ProjectCreationContextProps | null>(null);

/**
 * Hook providing the ProjectCreationContext
 * Removes the need for making null-check whenever the context is used
 * Must be used within an ProjectCreationContext
 */
export function useProjectCreationContext(): ProjectCreationContextProps {
  const context = useContext(ProjectCreationContext);

  if (!context) {
    throw new Error(
      "useProjectCreationContext() has to be used within a ProjectCreationContext."
    );
  }

  return context;
}
